// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTag as RawLucideTag } from "lucide-react";
export const LucideTag = /* @__PURE__ */ createIcon(RawLucideTag, "LucideTag", 2);
